import {
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  WaterDrop as WaterDropIcon,
} from "@mui/icons-material";
import {
  alpha,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Container,
  Grid,
  Snackbar,
  Alert,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Declaracoes = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const declaracoes = [
    {
      id: "cdnslam",
      nome: "CDNSLAM",
      descricao: "Certidão Declaratória de Não Sujeição ao Licenciamento Ambiental",
      icon: AssignmentIcon,
      cor: theme.palette.primary.main,
      rota: "/interessado/declaracoes/cdnsla",
      emBreve: false,
    },
    {
      id: "isencao",
      nome: "Isenção de Licenciamento",
      descricao: "Declaração de Isenção de Licenciamento Ambiental",
      icon: DescriptionIcon,
      cor: theme.palette.warning.main,
      rota: "/interessado/declaracoes/isencao",
      emBreve: false,
    },
    {
      id: "dispensa",
      nome: "Dispensa de Licenciamento",
      descricao: "Declaração de Dispensa do Licenciamento Ambiental (Saneamento Ambiental)",
      icon: WaterDropIcon,
      cor: theme.palette.secondary.main,
      rota: null,
      emBreve: true,
    },
  ];

  const handleCardClick = (declaracao) => {
    if (declaracao.rota) {
      navigate(declaracao.rota);
    } else {
      setSnackbarOpen(true);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 }, px: { xs: 2, sm: 3 } }}>
      <Box
        sx={{
          mb: { xs: 3, sm: 4 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
        }}
      >
        <AssignmentIcon
          sx={{ fontSize: { xs: 28, sm: 32 }, mr: { xs: 0, sm: 2 }, color: theme.palette.primary.main }}
        />
        <Typography
          variant="h4"
          component="h1"
          fontWeight="bold"
          color="primary.main"
          sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2.125rem" } }}
        >
          Declarações / Requerimentos
        </Typography>
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: { xs: 3, sm: 4 } }}>
        Selecione o tipo de declaração ou requerimento que deseja emitir:
      </Typography>

      <Grid container spacing={{ xs: 2, md: 3 }}>
        {declaracoes.map((declaracao) => {
          const IconComponent = declaracao.icon;
          return (
            <Grid item xs={12} sm={6} md={4} key={declaracao.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  border: `2px solid ${alpha(declaracao.cor, 0.2)}`,
                  transition: "all 0.3s ease",
                  position: "relative",
                  opacity: declaracao.emBreve ? 0.75 : 1,
                  "&:hover": {
                    boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                    transform: "translateY(-4px)",
                    borderColor: declaracao.cor,
                  },
                  cursor: "pointer",
                }}
              >
                {declaracao.emBreve && (
                  <Chip
                    label="Em breve"
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 1,
                      backgroundColor: alpha(declaracao.cor, 0.15),
                      color: declaracao.cor,
                      fontWeight: "bold",
                    }}
                  />
                )}
                <CardActionArea
                  onClick={() => handleCardClick(declaracao)}
                  sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      pt: { xs: 2, sm: 3 },
                      px: { xs: 2, sm: 3 },
                      pb: { xs: 2, sm: 3 },
                      flexGrow: 1,
                    }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: "50%",
                        backgroundColor: alpha(declaracao.cor, 0.1),
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconComponent sx={{ fontSize: 40, color: declaracao.cor }} />
                    </Box>
                    <Typography
                      variant="h6"
                      component="h2"
                      fontWeight="bold"
                      sx={{ mb: 1, color: declaracao.cor }}
                    >
                      {declaracao.nome}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                      {declaracao.descricao}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="info" sx={{ width: "100%" }}>
          Funcionalidade em breve
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Declaracoes;
